// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> sunrise-management-preferred -> casa-madrid
// Generated: 2026-10-21T13:17:52.741Z
// Counts: 1 design, 62 content, 17 slot group, 6 collection binding, 7 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our one-, two- and three-bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Availability and Pricing</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_home_neighborhood_blurb"
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore <span data-type=\"field-token\" data-field=\"property_address_city\"></span> step by step.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=160/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp",
    "generatedValue": null,
    "mappedField": "property_company_icon"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_secondary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Property Photos</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.source": {
    "overrideType": "VALUE",
    "customValue": "entrata",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": "<p>See what life at <span data-type=\"field-token\" data-field=\"property_name\"></span> is all about.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Life is easier at Casa Madrid.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Casa Madrid in Chula Vista, CA, embrace comfort and style with premium one, two, and three-bedroom floor plans. Enjoy resort-style amenities, including a sparkling pool, BBQ area, and pet-friendly living, all designed for your lifestyle. Use our interactive map to explore the community and view available apartment homes.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Casa Madrid in Chula Vista, CA—a tranquil garden community that feels like home. Here, you’ll enjoy all the comforts of modern living, paired with personalized attention from our warm and friendly on-site management team. Nestled in a peaceful neighborhood, Casa Madrid is ideally situated near shopping, dining, and more, offering you both beauty and convenience in one perfect location.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-3715-71e9-bad8-f71ae633868d.webp"
      }
    }
  },
  "floorplanslist.card_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-2a3d-7647-a4e6-29165684ea03.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019eba81-6539-700e-8aa7-ea67048230f0.webp"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162417/019d06cf-4134-73f9-aa2c-2cbcff86a11a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Sunrise Management logo"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019fa9a9-e79e-7183-a050-14978f5ac1a6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Smiling woman in a swimming pool."
      }
    }
  },
  "ctasection.card1_image": {
    "sourceIndex": 11,
    "fieldOverrides": null
  },
  "ctasection.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019fa9b0-3983-72df-bce5-3ca094f0c823.webp",
        "valueSource": "stock"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "A serene tabby cat with striking eyes lounged comfortably on a wooden floor, captured indoors."
      }
    }
  },
  "ctasection.card3_image": {
    "sourceIndex": 1,
    "fieldOverrides": null
  },
  "neighborhoodcallout.image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167026/019fa9a9-f3a8-7788-899f-883481b05fa6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman in a red bikini splashing in a swimming pool."
      }
    }
  },
  "neighborhoodcallout.image_3": {
    "sourceIndex": 14,
    "fieldOverrides": null
  },
  "propertyoverview.lifestyle_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167026/019fa9a9-e79e-7183-a050-14978f5ac1a6.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Smiling resident enjoying a swim in the Casa Madrid community pool."
      }
    }
  },
  "propertyoverview.lifestyle_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449167026/019fa9aa-03a0-759b-b264-9dcee05e9aa2.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Resident relaxing poolside with a drink at Casa Madrid."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": [
      "custom_a0714e31-925d-45ae-b312-dbc96ce4ec14"
    ],
    "orderedIds": [
      "custom_f7440b0e-d7e7-4890-aaaf-8bdbef39deac",
      "custom_63efa876-a55e-439c-bb0a-d679b3d11099",
      "custom_fa18d873-a7c6-4a24-a0fc-f5035a74f787",
      "custom_31f3c530-721e-491f-9ca1-6e9f835353f2",
      "custom_a0714e31-925d-45ae-b312-dbc96ce4ec14",
      "custom_753396a4-d7f0-402e-8049-05d19c8f1ef3",
      "custom_ebc73d50-c9b7-47dd-9152-bc183b48df0b",
      "custom_b288bf15-4729-43fc-a1c4-4a08bc8e962e",
      "custom_3180edb8-09a0-4728-a154-9825943946b5",
      "custom_b0df7779-4fc2-4f4a-b815-5c665276898d",
      "custom_68e63d7e-1693-4d9d-8f09-8e01660b69c8",
      "custom_d313eb87-56c2-4a60-bb18-3a2c36e52a24",
      "custom_059332a4-641c-405e-b139-4d974890e298",
      "custom_cddbb629-be8c-4c61-87af-b12c8ac7a9b7",
      "custom_dd38acfb-0a0c-4013-a636-f746f88c4d8f",
      "custom_d5896a8c-26be-444c-95a7-0a1d9c28f8a4",
      "custom_5d655704-9f80-4261-bb79-6b66eeb9540d",
      "custom_d0fd0fbc-4a07-488a-a612-3c626d2b2a8b",
      "custom_ecbb9e72-998d-40c9-8a5b-50e717f7cacc",
      "custom_19ffc886-e19d-446a-8553-7344ef2e53ec",
      "custom_14846974-c3fc-47ae-91f1-63e676e0fb8b"
    ],
    "hiddenIndices": [
      3
    ],
    "ordering": [
      20,
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "amenitieslist.communityPhotos": {
    "limit": null,
    "hiddenIds": [
      "ec_e341c73e779fee5c63834194"
    ],
    "orderedIds": [
      "ec_c31367b106eec6281f1580bb",
      "ec_8f4a277591b45afbce3335c2",
      "ec_b571ddd9e6b6440d6b5a467b",
      "ec_e341c73e779fee5c63834194",
      "ec_2231e8a8441e51d0b4801f00",
      "ec_edd3d283507d5a1a76287301",
      "ec_88e2fab71dad98dc6752fd6a",
      "ec_a8271cfa679dd361b47544c2",
      "ec_eb1992b7c4e03c52b89c81ae",
      "ec_31817b5f7928a39f41cc8dd1",
      "ec_6fa0f029e82739b3d4d8d111",
      "ec_c0aa3ed20e6ed8f2ffd405d3",
      "ec_0b478987616bfb8bc4d22fa5",
      "ec_8252335ae1b5a88d68d4f615",
      "ec_92acea6953a14ab6809a2f6d",
      "ec_181a58a78933c3f5e798993c",
      "ec_09dfafcb62cce3c32eaff919"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_5b368c16d3d296902bea9cc5"
    ],
    "orderedIds": [
      "ec_8f4a277591b45afbce3335c2",
      "ec_b571ddd9e6b6440d6b5a467b",
      "ec_e341c73e779fee5c63834194",
      "ec_92acea6953a14ab6809a2f6d",
      "ec_181a58a78933c3f5e798993c",
      "ec_09dfafcb62cce3c32eaff919",
      "ec_c31367b106eec6281f1580bb",
      "ec_2231e8a8441e51d0b4801f00",
      "ec_edd3d283507d5a1a76287301",
      "ec_88e2fab71dad98dc6752fd6a",
      "ec_a8271cfa679dd361b47544c2",
      "ec_eb1992b7c4e03c52b89c81ae",
      "ec_c0aa3ed20e6ed8f2ffd405d3",
      "ec_8252335ae1b5a88d68d4f615",
      "ec_0b478987616bfb8bc4d22fa5",
      "ec_6fa0f029e82739b3d4d8d111",
      "ec_31817b5f7928a39f41cc8dd1",
      "ec_afbb62d70eb28f16183fde61",
      "ec_1cdc30d9af5b666f6a069b2f",
      "ec_ea5ef592417ad47b08524431",
      "ec_d89580a0d0f44fb9b0345037",
      "ec_83a1febd19c1d12eb281db29",
      "ec_774b618a04ea03d743d95150",
      "ec_0f148d2ac65b437565e0e2e2",
      "ec_5b02d5aec9246cc673cb74a6",
      "ec_e209bd3709d4a43029384860",
      "ec_e239ac2c32d1dad52c0c854a",
      "ec_e9eb686db919b5bd69d7986e",
      "ec_9b0b0a26829fb01cddb5cdcf",
      "ec_e9d5c26b7be92122e30fa89e",
      "ec_11aeaa57dbeb9cb9b15ff69a",
      "ec_5b368c16d3d296902bea9cc5"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "reviewscallout.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": [
      "ec_3ac3c272e627f1e681bfcd8b",
      "ec_17c9d8eda9aecce6f85ddc68",
      "ec_bd9ad13dca42e3c5dcf1242c",
      "ec_2d5f9e600769cd698cc72675",
      "ec_58d9521d7795d2f974bd0323"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "entrata-chatbot",
      "blockId": "entrata-chatbot",
      "position": 0
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
